<template>
    <div class="topicComment">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>话题PK</el-breadcrumb-item>
            <el-breadcrumb-item>评论审核</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content-box">
            <div class="topic-list">
                <el-select v-model="user.current" clearable filterable placeholder="请选择创建者或输入关键字">
                    <el-option v-for="userItem in user.list" :key="userItem.userId" :label="userItem.userName" :value="userItem"></el-option>
                </el-select>
                <el-select v-model="topic.current" clearable filterable placeholder="请选择话题或输入关键字" @change="changeTopic">
                    <el-option v-for="topicItem in getTopicList" :key="topicItem.topicId" :label="topicItem.topicTitle" :value="topicItem"></el-option>
                </el-select>
            </div>
            <div class="comment-list" v-if="formatCommentList">
                <div class="refresh-btn-box" @click="refreshComment">
                    <img src="../../../assets/refresh.png" alt="刷新">
                </div>
                <ul>
                    <li class="comment-item-box" v-for="(commentItem, index) in formatCommentList" :key="index">
                        <div class="comment-item">
                            <div class="user-info-box">
                                <span class="head-icon" v-if="commentItem.userPortrait.indexOf('http') !== -1">
                                    <img v-bind:src="commentItem.userPortrait" alt="一点资讯" >
                                </span>
                                <div class="user-name">{{commentItem.userName}}</div>
                            </div>
                            <div class="comment-content">
                                <div class="text-box">{{commentItem.commentContent}}</div>
                                <div class="image-box" v-if="commentItem.commentImg.indexOf('http') !== -1">
                                    <img v-bind:src="commentItem.commentImg" alt="一点资讯">
                                </div>
                            </div>
                            <div class="create-time">{{commentItem.commentTime}}</div>
                        </div>
                        <div class="comment-options">
                            <div class="delete" @click="deleteComment(commentItem.commentId)">
                                <img src="../../../assets/delete.png" >
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
export default {
    data(){
        return {
            user: {
                current: null,
                list: null
            },
            topic: {
                current: null,
                list: null
            },
            comment: {
                list: null
            }
        };
    },
    mounted(){
        this._init();
    },
    computed: {
        getTopicList(){
            if (!this.user.current) {
                return this.topic.list;
            } else {
                let userId = this.user.current.userId;
                let topicList = this.topic.list;
                return topicList.filter((topicItem)=>{
                    return topicItem.createUser === userId;
                });
            }
        },
        formatCommentList(){
            if (!this.topic.current || !this.comment.list) {
                return false;
            } else {
                let commentList = this.comment.list;
                return commentList.filter((commentItem)=>{
                    commentItem.commentTime = moment(commentItem.commentTime).format('YYYY-MM-DD');
                    return true;
                });
            }
        }
    },
    methods: {
        _getUserList() {
            this.$http.get(CONFIG.HOST + "/users/list" + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.user.list = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _getTopicList(){
            this.$http.get(CONFIG.HOST + '/topicPK/topics/getAllTopics' + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.topic.list = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _getCommentList(topicId = -1){
            this.$http.get(CONFIG.HOST + '/topicPK/comments/getAllComments/'+ topicId + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.comment.list = result.data;
                    if (Array.isArray(this.comment.list) && this.comment.list.length > 0) {
                        this.$message.success("成功获取评论列表");
                    } else {
                        this.$message.info("暂无用户评论");
                    }
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _confirmMessage(message, success = ()=>{}, cancel = ()=>{}) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(success).catch(cancel);          
        },
        _deleteComment(commentId = -1){
            this.$http.put(CONFIG.HOST + '/topicPK/comments/delComment/' + commentId).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】成功删除commentId=' + commentId + '的评论'
                    });
                    this._getCommentList(this.topic.current.topicId);
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _init(){
            this._getUserList();
            this._getTopicList();
        },
        changeTopic(topicItem){
            this._getCommentList(this.topic.current.topicId);
        },
        deleteComment(commentId = -1){
            this._confirmMessage('是否确定删除commentId=' + commentId + '的评论？', ()=>{
                if (commentId < 0) {
                    this.$notify.error({
                        message: '【营销平台】commentId=' + commentId + '的评论不存在'
                    });
                    return;
                }
                this._deleteComment(commentId);
            });
        },
        refreshComment(){
            this._getCommentList(this.topic.current.topicId);
        }
    }
}
</script>
<style lang="less">
    .topicComment{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        .content-box{
            height: 100%;

            .topic-list{
                width: 30%;
                height: 85%;

                float: left;

                text-align: left;
                border-right:1px #efefef solid;
                .el-select{
                    width: 90%;
                    margin-bottom: 20px;
                }
            }
            .comment-list{
                float: left;
                width: 480px;
                height: 550px;
                margin-left: 20px;
                position: relative;
                overflow-y: auto;
                border: 1px solid #ccc;
                padding: 10px 0;
                .refresh-btn-box{
                    width: 40px;
                    height: 40px;

                    position: absolute;
                    left: 0;
                    top: 0;
                    z-index: 10000;

                    border-radius: 50%;

                    background: #fff;
                    cursor: pointer;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                ul, ol, li{
                    list-style-type: none;
                }
                ul{
                    .comment-item-box:hover{
                        .comment-options{
                            display: block;
                            width: 100%;
                            height: 40px;

                            position: absolute;
                            left: 0;
                            bottom: 10px;
                            background: rgba(0, 0, 0, 0.7);

                            .delete{
                                width: 40px;
                                height: 100%;
                                cursor: pointer;
                                img{
                                    margin-top: 10px;

                                    width: 50%;
                                    height: 50%;
                                }
                            }
                        }
                    }
                    .comment-options{
                        display: none;
                    }
                    .comment-item-box{
                        float: left;
                        margin-left: 10px;
                        position: relative;

                        .comment-item{
                            width: 200px;
                            border: 1px solid #000;

                            text-align: left;
                            padding: 8px;
                            margin-bottom: 10px;

                            .user-info-box{
                                width: 100%;
                                height: 40px;
                                display: flex;
                                display: -webkit-box;
                                display: -webkit-flex;

                                font-size: 18px;

                                padding-bottom: 8px;

                                border-bottom: 1px solid #000;

                                overflow: hidden;
                                .head-icon{
                                    width: 30%;
                                    img{
                                        height: 100%;
                                        border-radius: 50%;
                                    }
                                }
                                .user-name{
                                    width: 70%;
                                    line-height: 40px;
                                    
                                }
                            }
                            .comment-content{
                                padding-top: 8px;
                                .text-box{

                                }
                                .image-box{
                                    text-align: center;
                                    img{
                                        width: 100%;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>





// WEBPACK FOOTER //
// Comment.vue?4108e92e